var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CompanyForm',{attrs:{"id":_vm.id,"readOnlyUniqueId":""},on:{"cancel":function($event){return _vm.$emit('cancel')},"submit":_vm.submit}})
}
var staticRenderFns = []

export { render, staticRenderFns }